export const shareIconsData = (title, uri) => {
    return [
        {
            platform: 'Twitter',
            url: `https://twitter.com/intent/tweet?url=https://jewsforjesus.org${uri}&text=${title}`
        },
        {
            platform: 'Facebook',
            url: `https://www.facebook.com/sharer/sharer.php?u=https://jewsforjesus.org${uri}&quote=${title}.`
        },
        {
            platform: 'LinkedIn',
            url: `https://www.linkedin.com/sharing/share-offsite/?url=https://jewsforjesus.org${uri}`
        },
        {
            platform: 'Email',
            url: `mailto:?body=https://jewsforjesus.org${uri}`
        }
    ];
};
